import { getError } from '../../utils/requestUtils';
import {
  LIST_DEALS,
  START,
  SUCCESS,
  ERROR,
  CLEAN_DEALS,
  SET_DEAL_ATTRIBUTES,
  LIST_SWITCHED_DEALS,
  CLEAN_SWITCHED_DEALS, FIND_DEAL, SET_RELOAD_DEAL
} from '../actions/types';

const INITIAL_STATE = {
  deals: [],
  switchedDeals: [],
  pagination: null,
  deal: null,
  reloadDeal: false,

  listDeals: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  const data = action.payload?.data;
  const error = getError(action.payload);

  switch (action.type) {
    case LIST_DEALS + START:
      return { ...state, listDeals: { loading: true } };
    case LIST_DEALS + SUCCESS:
      return {
        ...state,
        listDeals: { loading: false },
        deals: data.result.items,
        pagination: data.result.pagination
      };
    case LIST_DEALS + ERROR:
      return { ...state, listDeals: { loading: false, error } };

    case CLEAN_DEALS + SUCCESS:
      return {
        ...state,
        listDeals: { loading: false },
        deals: [],
        pagination: null,
        ...action.payload
      };

    case SET_DEAL_ATTRIBUTES:
      return {
        ...state,
        deals: state.deals.map((item) => {
          if (item.home?.id === action.payload.homeId) {
            return { ...item, ...action.payload.attributes };
          }
          return item;
        })
      };

    case LIST_SWITCHED_DEALS + START:
      return { ...state };
    case LIST_SWITCHED_DEALS + SUCCESS:
      return {
        ...state,
        switchedDeals: data.result.items,
      };
    case LIST_SWITCHED_DEALS + ERROR:
      return { ...state };

    case CLEAN_SWITCHED_DEALS + SUCCESS:
      return {
        ...state,
        switchedDeals: [],
        ...action.payload
      };

    case FIND_DEAL + START:
      return { ...state, findDeal: { loading: true } };
    case FIND_DEAL + SUCCESS:
      return { ...state, findDeal: { loading: false }, deal: data.item };
    case FIND_DEAL + ERROR:
      return { ...state, findDeal: { loading: false, error } };

    case SET_RELOAD_DEAL:
      return { ...state, reloadDeal: action.payload.reload };

    default:
      return { ...state };
  }
}
